export default __webpack_public_path__ + "static/media/zipfile.34e24037.png";